<template>
  <div
    class="d-flex align-items-stretch quick-filter-wrap"
    :class="$attrs.class"
  >
    <!-- Dropdown Label -->
    <div class="label-dropdown position-relative">
      <button
        class="dropdown-toggle text-capitalize"
        type="button"
        @click="toggleDropdown"
      >
        {{ selectedLabel }}
      </button>
      <ul
        v-if="dropdownOpen"
        class="dropdown-menu show "
        style="position: absolute; top: 70%; z-index: 10;"
      >
        <li
          v-for="(label, index) in labels"
          :key="index"
          :class="{
            'selected-option': label === selectedLabel,
          }"
        >
          <a class="dropdown-item" href="#" @click.prevent="selectLabel(label)">
            {{ label }}
          </a>
        </li>
      </ul>
    </div>

    <!-- Input with Search Icon -->
    <div class="dropdown-input-wrap position-relative flex-grow-1">
      <input
        type="text"
        class="dropdown-input w-100 pe-5"
        :placeholder="placeholders[selectedLabel]"
        v-model="inputValue"
        @keyup.enter="triggerSearch"
      />
      <i
        class="fa fa-search position-absolute text-muted"
        style="top: 50%; right: 1rem; transform: translateY(-50%); pointer-events: none;"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickFilterInput",
  props: {
    labels: {
      type: Array,
      default: () => ["Name", "System ID", "Rep Code"],
    },
    placeholders: {
      type: Object,
      default: () => ({
        "Name": "Enter Name",
        "System ID": "Enter System ID",
        "Rep Code": "Enter Rep Code",
      }),
    },
    preserveInputOnLabelChange: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedLabel:this.labels[0] || "",
      inputValue: "",
      inputValuesByLabel: {},
      dropdownOpen: false,
    };
  },
  methods: {
    clearInputValues() {
      this.inputValuesByLabel = {};
      this.inputValue = "";
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectLabel(label) {
      if (this.preserveInputOnLabelChange) {
        this.inputValuesByLabel = {
          ...this.inputValuesByLabel,
          [this.selectedLabel]: this.inputValue,
        };
      }
      this.selectedLabel = label;
      this.inputValue = this.preserveInputOnLabelChange
        ? this.inputValuesByLabel[label] || ""
        : "";
      this.dropdownOpen = false;
    },
    triggerSearch() {
      this.$emit("search", {
        label: this.selectedLabel,
        value: this.inputValue,
      });
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.quick-filter-wrap {
  max-height: 50px;
}
.quick-filter-wrap .label-dropdown {
  border: none;
  border-radius: 0;
}
.quick-filter-wrap .label-dropdown button {
  border: none;
  border-radius: 6px 0 0 6px;
  background: #f3f3f3;
  color: #254050;
  padding: 0.75rem 1rem;
  font-size: 14px;
  font-weight: 600;
}
.label-dropdown button:hover,
.label-dropdown button:active {
  border: none !important;
}
.quick-filter-wrap .dropdown-menu{
  padding: 0;
  overflow: hidden;
}
.quick-filter-wrap .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #717171;
  padding: 0.5rem 0.8rem;
}
.quick-filter-wrap .dropdown-menu li:first-child {
  border-bottom: solid 1px #ced4da;
}
.quick-filter-wrap .dropdown-menu .selected-option a {
  color: #03c6ec;
  font-weight: 400;
}
.quick-filter-wrap .dropdown-menu .selected-option a:active{
  background-color: #03c6ec;
  color: #fff;
}
.quick-filter-wrap .dropdown-input {
  border: none;
  border-radius: 0 6px 6px 0;
  background-color: #fafbfd;
  font-size: 14px;
  padding: 0.75rem 1rem;

  height: 100%;
}
.quick-filter-wrap .dropdown-input:focus {
  border: none;
}
</style>
